import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../common/Button';
import routerImage from '../../../../../../assets/icons/download-modal/router.png';
import styles from './DownloadModalRouterSlide.scss';

interface DownloadModalRouterSlideProps {
  onClick: () => void;
}

const DownloadModalRouterSlide = ({ onClick }: DownloadModalRouterSlideProps) => (
  <div className={styles.slide}>
    <span className={styles.newLabel}>
      <FormattedMessage id="profile.downloadModal.routerSlide.newLabel" defaultMessage="New" />
    </span>

    <img src={routerImage} width="226" height="157" alt="" />

    <h4 className={styles.title}>
      <FormattedMessage id="profile.downloadModal.routerSlide.title" defaultMessage="Manual router setup" />
    </h4>
    <p className={styles.subtitle}>
      <FormattedMessage
        id="profile.downloadModal.routerSlide.subtitle"
        defaultMessage="Available for AsusWRT, DD-WRT, OpenWRT, and Tomato. You can add one router per free slot on your account. Click the button below to set up ClearVPN on your router."
      />
    </p>

    <Button kind="primary" className={styles.button} buttonSize="small" onClick={onClick}>
      <FormattedMessage id="profile.downloadModal.routerSlide.button" defaultMessage="Continue" />
    </Button>
  </div>
);

export default DownloadModalRouterSlide;
